import axios from 'axios'
import { config } from '../config'
// @ts-ignore
import { Keycloak } from 'keycloak-js'
import { ResponseError } from '../types/response.type'

export const createAxiosInstance = () =>
  axios.create({
    baseURL: `${config.baseUrl}/api`,
  })

export const axiosInstance = createAxiosInstance()

let isInterceptorAdded = false

export const configureAxiosAuth = (
  keycloak: Keycloak.KeycloakInstance,
  instance = axiosInstance,
) => {
  instance.interceptors.request.use(
    (config) => {
      const currentToken = keycloak.token
      config.headers.Authorization = `Bearer ${currentToken}`
      return config
    },
    (error) => Promise.reject(error),
  )

  if (!isInterceptorAdded) {
    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          console.warn('Received 401, redirecting to login')
          keycloak.logout({
            redirectUri: window.location.origin + '/login',
          })
          return Promise.reject(error)
        }
        const msg = error.response?.data?.message ?? error.message
        return Promise.reject(new ResponseError(msg))
      },
    )
    isInterceptorAdded = true
  }
}

// Added this for testability
export const __resetInterceptorFlag = () => {
  isInterceptorAdded = false
}
